import { UCMARKETINGPAGES } from "../../../utils/useCasesMarketingPages";

export const UseCaseFeatures2 = UCMARKETINGPAGES.map(useCase => (
    {
        icon: useCase.iconPath,
        text: useCase.primaryText
    }
));